import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import getAuth for authentication
import { getFirestore } from "firebase/firestore";  // Import Firestore for db
import { getStorage } from "firebase/storage";  // Optional, if you're using storage

const firebaseConfig = {
  apiKey: "AIzaSyA4zxi-MYNZoPQ1-xeVGm05Wv59qIOuECU",
  authDomain: "ekanayake-optical.firebaseapp.com",
  projectId: "ekanayake-optical",
  storageBucket: "ekanayake-optical.firebasestorage.app",
  messagingSenderId: "184949180163",
  appId: "1:184949180163:web:bc4a1e5055c3b9a9b48b36"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);  // Initialize Firebase Authentication
const db = getFirestore(app);  // Initialize Firestore
const storage = getStorage(app);  // Initialize Firebase Storage (if needed)

export { auth, db, storage };